import { RelatedPerson } from "@medplum/fhirtypes";
import { FhirBundleSdk, Smart } from "@metriport/fhir-sdk";

export type RelatedPersonRowData = {
  id: string;
  name: string;
  relationships: string;
  contacts: string;
  addresses: string;
  originalData: Smart<RelatedPerson>;
};

export function getRelatedPersonRows({
  bundle,
}: {
  bundle: FhirBundleSdk;
}): RelatedPersonRowData[] {
  try {
    const relatedPersons = bundle.getRelatedPersons();
    return relatedPersons.map(rp => {
      // Extract name
      const name =
        rp.name?.map(n => n.text || `${n.given?.[0] || ""} ${n.family || ""}`).join(", ") || "-";

      // Extract relationships
      const relationships =
        rp.relationship?.map(r => r.coding?.[0]?.display || r.text || "-").join(", ") || "-";

      // Extract contact information
      const phoneNumbers = rp.telecom
        ?.filter(t => t.system === "phone")
        .map(t => t.value || "-")
        .join(", ");
      const emails = rp.telecom
        ?.filter(t => t.system === "email")
        .map(t => t.value || "-")
        .join(", ");
      const contacts = [phoneNumbers, emails].filter(Boolean).join(", ") || "-";

      // Extract addresses
      const addresses =
        rp.address
          ?.map(a =>
            `${a.line?.[0] || ""} ${a.city || ""} ${a.state || ""} ${a.postalCode || ""}`.trim()
          )
          .join(", ") || "-";

      return {
        id: rp.id || "-",
        name,
        relationships,
        contacts,
        addresses,
        originalData: rp,
      };
    });
  } catch (error) {
    console.warn("RelatedPerson not available in FhirBundleSdk:", error);
    return [];
  }
}
